
<div>
  <!-- 密码修改 -->
  <a-modal
    title="密码修改"
    :keyboard="false"
    :maskClosable="false"
    :closable="false"
    :confirmLoading="loading"
    :cancelButtonProps="{ props: { disabled: loading } }"
    v-model="show"
    @cancel="cancelUpdatePassword"
    @ok="handleUpdatePassword"
  >
    <a-form
      :autoFormCreate="
        form => {
          this.form = form;
        }
      "
    >
      <a-form-item
        label="旧密码"
        v-bind="formItemLayout"
        fieldDecoratorId="oldPassword"
        :fieldDecoratorOptions="{
          rules: [
            { required: true, message: '请输入旧密码' },
            { validator: this.handleOldPassowrd },
          ],
          validateTrigger: ['blur'],
        }"
      >
        <a-input
          type="password"
          autocomplete="false"
          v-model="oldPassword"
          placeholder="请输入旧密码"
        ></a-input>
      </a-form-item>
      <a-popover
        placement="rightTop"
        trigger="click"
        :visible="state.passwordLevelChecked"
      >
        <template slot="content">
          <div :style="{ width: '240px' }">
            <div :class="['update-password', passwordLevelClass]">
              强度：<span>{{ passwordLevelName }}</span>
            </div>
            <a-progress
              :percent="state.percent"
              :showInfo="false"
              :strokeColor="passwordLevelColor"
            />
            <div style="margin-top: 10px;">
              <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
            </div>
          </div>
        </template>
        <a-form-item
          label="新密码"
          v-bind="formItemLayout"
          fieldDecoratorId="password"
          :fieldDecoratorOptions="{
            rules: [
              { required: true, message: '至少6位密码，区分大小写' },
              { min: 6, message: '至少6位密码，区分大小写' },
              { validator: this.handlePasswordLevel },
            ],
            validateTrigger: ['change', 'blur'],
          }"
        >
          <a-input
            type="password"
            @click="handlePasswordInputClick"
            v-model="newPassword"
            autocomplete="false"
            placeholder="至少6位密码，区分大小写"
          ></a-input>
        </a-form-item>
      </a-popover>
      <a-form-item
        label="再次确认"
        v-bind="formItemLayout"
        fieldDecoratorId="password2"
        :fieldDecoratorOptions="{
          rules: [
            { required: true, message: '至少6位密码，区分大小写' },
            { validator: this.handlePasswordCheck },
          ],
          validateTrigger: ['change', 'blur'],
        }"
      >
        <a-input
          type="password"
          autocomplete="false"
          placeholder="确认密码"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</div>
